import { Link } from 'react-router-dom';
import './Footer.css';

const NAV_LINKS = [
  { to: '/', label: 'Strona główna' },
  { to: '/#about', label: 'Jak to działa' },
  { to: '/#pobierz', label: 'Pobierz' },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__left">
          <nav className="footer__nav" aria-label="Nawigacja">
            {NAV_LINKS.map((link) => (
              <Link key={link.to} to={link.to}>
                {link.label}
              </Link>
            ))}
          </nav>
          <span className="footer__brand">FindAlikeMe © 2026</span>
        </div>

        <div className="footer__legal">
          <a href="#regulamin">Regulamin</a>
          <a href="#polityka-prywatnosci">Polityka prywatności</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
